import React from "react";
import { AppBar, Toolbar, Typography, Button, Box } from "@mui/material";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import logo from "../assets/home1.jpg"; // Replace with your logo
import "../styles/Navbar.css";

const Navbar = () => {
  const navItems = [
    { text: "Home", path: "/" },
    { text: "Labour Contract", path: "/page1" },
    { text: "Material Contract", path: "/page2" },
    { text: "Cost Estimator", path: "/estimator" }, // ✅ New Cost Estimator link
    { text: "Enquiries", path: "/enquiries" },
  ];

  return (
    <AppBar position="sticky" className="navbar" elevation={3}>
      <Toolbar className="navbar-toolbar">
        {/* Logo + Title */}
        <Box className="navbar-logo">
          <motion.img
            src={logo}
            alt="Logo"
            className="logo-img"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
          />
          <Typography variant="h6" className="navbar-title">
            RM INFRASTRUCTURES
          </Typography>
        </Box>

        {/* Navigation Links */}
        <Box className="navbar-links">
          {navItems.map((item, index) => (
            <motion.div
              key={item.text}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              transition={{ type: "spring", stiffness: 250 }}
            >
              <Button
                component={Link}
                to={item.path}
                className="nav-button"
                color="inherit"
              >
                {item.text}
              </Button>
            </motion.div>
          ))}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
